import React, { Component } from 'react';
import { NavMenu } from './site-navigation/nav-menu/NavMenu';
import { SiteFooter } from './site-footer/SiteFooter';

export class Layout extends Component<any, any> {
  static displayName = Layout.name;

  render () {
    return (
      <div>
        <NavMenu />
        {this.props.children}
        <SiteFooter />
      </div>
    );
  }
}
